<!-- 
	This is the sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
	<div>
		<!-- Sign Up Image And Headings -->
		<div class="sign-up-header" :style="{backgroundImage: `url(${$STATIC_URL}/login_bg.jpg)`}">
			<div class="content">
				<h1 class="mb-5">{{ $t('register_1') }}</h1>
				<p class="text-lg">{{ $t('register_2') }}</p>
			</div>
		</div>
		<!-- / Sign Up Image And Headings -->

		<!-- Sign Up Form -->
		<a-card :bordered="false" class="card-signup header-solid h-full">
            <a-steps :current="step" size="small" style="padding: 25px 45px 25px;">
                <a-step :title="$t('register_3')"/>
                <a-step :title="$t('register_4')"/>
                <a-step :title="$t('register_5')"/>
            </a-steps>

			<a-form
				id="components-form-demo-normal-login"
				class="login-form"
				@submit="handleSubmit"
			>
                <template v-if="step == 0">
                    <a-form-item class="mb-10">
                        <a-input
                            v-model="member_email"
                            v-decorator="[
                            { rules: [{ required: true, message: $t('register_6') }] },
                            ]"
                            :placeholder="$t('register_7')"
                        >
                        </a-input>
                    </a-form-item>
                    <a-form-item class="mb-5">
                        <div class="code_input">
                            <a-input
                                v-model="captcha"
                                v-decorator="[
                                { rules: [{ required: true, message: $t('register_8') }] },
                                ]"
                                :placeholder="$t('register_9')"
                            >
                            </a-input>
                            <img :src="captchaImg" alt="" @click="getCaptcha()">
                        </div>
                    </a-form-item>
                </template>

                <template v-else-if="step == 1">
                    <a-form-item class="mb-5">
                        <a-input
                            v-model="email_vcode"
                            v-decorator="[
                            { rules: [{ required: true, message: $t('register_10') }] },
                            ]"
                            :placeholder="$t('register_11')"
                        >
                        </a-input>
                    </a-form-item>

                    <a-form-item class="mb-5">
                        <a-input
                            v-model="member_name"
                            v-decorator="[
                            { rules: [{ required: true, message: $t('register_12') }] },
                            ]"
                            :placeholder="$t('register_13')"
                        >
                        </a-input>
                    </a-form-item>

                    <a-form-item class="mb-5">
                        <a-input-password
                            v-model="member_passwd"
                            v-decorator="[
                            { rules: [{ required: true, message: $t('register_14') }] },
                            ]"
                            :placeholder="$t('register_15')"
                        >
                        </a-input-password>
                    </a-form-item>
                    
                </template>

                <a-form-item class="mb-10">
					<a-checkbox v-model="agree">
						{{$t('register_16')}} <a href="#" class="font-bold text-dark">{{$t('register_17')}}</a>
					</a-checkbox>
				</a-form-item>

                <template v-if="step == 0">
                    <a-form-item>
					    <a-button type="primary" block @click="onGetCode" class="login-form-button" :loading="codeLoading">{{$t('register_18')}}</a-button>
				    </a-form-item>
                </template>
                <template v-else-if="step == 1">
                    <a-form-item>
					    <a-button type="primary" block @click="handleSubmit" class="login-form-button" :loading="subLoading">{{$t('register_19')}}</a-button>
				    </a-form-item>
                </template>
			</a-form>
			<p class="font-semibold text-muted text-center">{{$t('register_21')}} <router-link to="/login" class="font-bold text-dark">{{$t('register_20')}}</router-link></p>
            <div id="googleLoginDiv" style="text-align:center; margin:10px 110px 0; "></div>
        </a-card>
		<!-- / Sign Up Form -->

	</div>
</template>

<script>

	export default ({
		data() {
			return {
                step: 0,

                captchaImg: '',
                access_token: '',
                codeLoading: false,

                type: 2,
                captcha: '',
                member_email: '',
                member_name: '',
                member_passwd: '',
                member_passwd2: '',
                email_vcode: '',
                email_token: '',

                agree: false,

                subLoading: false,
			}
		},
		beforeCreate() {
			// Creates the form and adds to it component's "form" property.
			// this.form = this.$form.createForm(this, { name: 'normal_login' });
		},
        created() {
            this.getCaptcha();
        },
        mounted() {
            // === 加载 Google 登录 SDK ===
            const script = document.createElement('script');
            script.src = "https://accounts.google.com/gsi/client";
            script.async = true;
            script.defer = true;
            script.onload = () => {
                google.accounts.id.initialize({
                    client_id: "872834967320-5fdiahaj6aac0alclrdt8ajj2i9ht2pk.apps.googleusercontent.com",
                    callback: this.handleGoogleLogin
                });
                google.accounts.id.renderButton(
                    document.getElementById("googleLoginDiv"),
                    { theme: "outline", size: "large", shape: "rectangular", logo_alignment: "center",locale:"en-Us" }
                );
            };
            document.head.appendChild(script);
        },
		methods: {
            handleGoogleLogin(response) {
                console.log("Google 登录返回 token：", response.credential);
                // 发给后端验证
                let params = {
                    token: response.credential,
                };
                this.$HTTP.post('/member/index/google_login', params).then(res => {
                    if (res.data.sts == 1) {
                        this.$store.dispatch('getInfo');
                        this.$APP_MANAGE.setLoginInfo(res.data.data.token);
                        this.$message.success({content: res.data.msg, duration: 1}).then(() => {
                            this.$router.replace('/user/info');
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            },
            // 获取图形验证码
            getCaptcha() {
                this.$HTTP.get('/api/api/captcha').then(res => {
                    if (res.data.sts == 1) {
                        this.captchaImg = res.data.data.data;
                        this.access_token = res.data.data.access_token;
                    }
                })
            },
            // 获取邮箱验证码
            onGetCode() {
                if(!this.agree) {
                    this.$message.error(this.$t('register_22'));
                    return
                }

                let params = {
                    captcha: this.captcha,
                    email: this.member_email,
                    access_token: this.access_token
                };
					
                
                this.codeLoading = true;
                this.$HTTP.post('/member/index/sms_email', params).then(res => {
                    this.codeLoading = false;
                    if (res.data.sts == 1) {
                        this.$message.success(res.data.msg,1).then(() => {
                            this.email_token = res.data.data.token;
                            this.step = 1;
                        });
                    } else {
                        this.$message.error(res.data.msg,1).then(() => {
                            this.captcha = '';
                            this.getCaptcha();
                        });
                    }
                })
            },

            

			// Handles input validation after submission.
			handleSubmit(e) {
                if(!this.agree) {
                    this.$message.error(this.$t('register_22'));
                    return
                }
				e.preventDefault();
                let params = {
                    type: this.type,
                    member_email : this.member_email,
                    member_name : this.member_name,
                    member_passwd : this.member_passwd,
                    email_vcode : this.email_vcode,
                    email_token : this.email_token
                }
                
                this.subLoading = true;
                this.$HTTP.post('/member/index/reg_check', params).then(res => {
                    this.subLoading = false;
                    if (res.data.sts == 1) {
                        this.$store.dispatch('getInfo');
                        this.$APP_MANAGE.setLoginInfo(res.data.data.token);
                        this.$message.success({content: res.data.msg, duration: 1}).then(() => {
                            this.$router.replace('/user/info');
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
			},
            
		},
	})

</script>

<style lang="scss">

    .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
        color: #fff;
    }

    .ant-card-body {
        padding: 16px 26px;
    }

    .code_input {
        display: flex;
        align-items: center;
        img {
            width: 90px;
            flex: none;
            margin-left: 15px;
            cursor: pointer;
        }
    }
</style>